export default __webpack_public_path__ + "static/media/excel.d6b8ba66.svg";